/* Menu hover add class JS*/
!function(factory){"use strict";"function"==typeof define&&define.amd?define(["jquery"],factory):"object"==typeof module&&module.exports?module.exports=factory(require("jquery")):jQuery&&!jQuery.fn.hoverIntent&&factory(jQuery)}(function($){"use strict";function track(ev){cX=ev.pageX,cY=ev.pageY}var cX,cY,_cfg={interval:100,sensitivity:6,timeout:0},INSTANCE_COUNT=0,compare=function(ev,$el,s,cfg){if(Math.sqrt((s.pX-cX)*(s.pX-cX)+(s.pY-cY)*(s.pY-cY))<cfg.sensitivity)return $el.off(s.event,track),delete s.timeoutId,s.isActive=!0,ev.pageX=cX,ev.pageY=cY,delete s.pX,delete s.pY,cfg.over.apply($el[0],[ev]);s.pX=cX,s.pY=cY,s.timeoutId=setTimeout(function(){compare(ev,$el,s,cfg)},cfg.interval)};$.fn.hoverIntent=function(handlerIn,handlerOut,selector){var instanceId=INSTANCE_COUNT++,cfg=$.extend({},_cfg);$.isPlainObject(handlerIn)?(cfg=$.extend(cfg,handlerIn),$.isFunction(cfg.out)||(cfg.out=cfg.over)):cfg=$.isFunction(handlerOut)?$.extend(cfg,{over:handlerIn,out:handlerOut,selector:selector}):$.extend(cfg,{over:handlerIn,out:handlerIn,selector:handlerOut});function handleHover(e){var ev=$.extend({},e),$el=$(this),hoverIntentData=$el.data("hoverIntent");hoverIntentData||$el.data("hoverIntent",hoverIntentData={});var state=hoverIntentData[instanceId];state||(hoverIntentData[instanceId]=state={id:instanceId}),state.timeoutId&&(state.timeoutId=clearTimeout(state.timeoutId));var mousemove=state.event="mousemove.hoverIntent.hoverIntent"+instanceId;if("mouseenter"===e.type){if(state.isActive)return;state.pX=ev.pageX,state.pY=ev.pageY,$el.off(mousemove,track).on(mousemove,track),state.timeoutId=setTimeout(function(){compare(ev,$el,state,cfg)},cfg.interval)}else{if(!state.isActive)return;$el.off(mousemove,track),state.timeoutId=setTimeout(function(){!function(ev,$el,s,out){var data=$el.data("hoverIntent");data&&delete data[s.id],out.apply($el[0],[ev])}(ev,$el,state,cfg.out)},cfg.timeout)}}return this.on({"mouseenter.hoverIntent":handleHover,"mouseleave.hoverIntent":handleHover},cfg.selector)}});

jQuery(document).ready(function($) {
	$('.list-menu li.has-children').each(function (e, t) {
      $(this).hoverIntent({
    	  sensitivity: 3,
          interval: 35,
          timeout: 250,
          over: function (e) {
             $(this).addClass('menu_item_hover')
          },
          out: function () {
             $(this).removeClass('menu_item_hover')
          }
		});
	});
});



/* Mega Menu JS */
jQuery(document).ready(function(n) {
  
var o = n('body'),
t = n('.lazy_menu:not(.calc_pos)');
0 < t.length && t.each(function () {
    initMegaMenu(n(this).closest('li.menu_has_offsets'));
});

  
n( window ).resize(function() {
0 < t.length && t.each(function () {
    initMegaMenu(n(this).closest('li.menu_has_offsets'));
});
});
  
function initMegaMenu(t) {
  	var O = jQuery,
        y,
    	g = O('body');
  
	if (!(O(window).width() <= 767)) {
		var e = O(window),
			i = g.hasClass('des_header_7'),
			n = (O('#menu_id').find(' > li.menu_has_offsets'), e.width()),
			o = O('#shopify-section-header'),
			a = o.outerWidth() + o.offset().left,
			r = g.hasClass('wrapper-boxed') || g.hasClass('wrapper-boxed-small') ? a : n,
			s = t.find(' > .sub-menu'),
      		ss = t.find(' > .cus.sub-menu')
              
      		var dd_w = ss.attr("data-width");
      		var md = ss.find(' > .page-width ');
      		var dw = md.width() + parseInt(60);
      		var ww = e.width();
      		
      		if (dw > ww ){
  				var set_w = ww - parseInt(80);
    			md.width(set_w);
			}		
			if (dw < ww ){
  				var set_w = ww - parseInt(80);
  				if(dd_w > set_w){	
    				md.width(set_w);
    			} else {
      				md.width(dd_w);
    			}
			}
      
		if (s.addClass('calc_pos').attr('style', ''), i) {
			var l = s.offset().top + s.outerHeight(),
				c = e.scrollTop() + e.outerHeight();
			c < l && s.css({
				top: c - l - 10
			})
		}
		if (!i) {
			var d = s.outerWidth(),
				f = s.offset(),
				p = t.hasClass('menu_wid_full') ? 0 : 10;
			if (d && f)
				if (0 <= d && t.hasClass('menu_center')) {
					var u = f.left + d / 2 - n / 2;
					s.css({
						left: -u
					})
				} else if (y && (f.left <= 0 || t.hasClass('menu_wid_full')) && t.hasClass('menu_has_offsets')) {
				u = -f.left;
				s.css({
					right: -u - p
				})
			} else if ((f.left + d >= r || t.hasClass('menu_wid_full')) && t.hasClass('menu_has_offsets')) {
				var h = f.left + d - r;
				s.css({
					left: -h - p
				})
			}
		}
	}
}
  
});

/* Mobile Menu JS */
jQuery(document).ready(function($) {
  var R = $;	
  var e = R('#menu-drawer');
  	e.on('click', ".has-children a.link[href='']", function (e) {
      e.preventDefault(),
      e.stopPropagation();
      var t = R(this),
      i = t.parent();
      o(t, i)
    });
    e.on('click', '.has-children .nav_link_icon', function (e) {
      e.preventDefault(),
      e.stopPropagation();
      var t = R(this),
      i = t.parent().parent();
      o(t, i)
    });
    var o = function (e, t) {
      t.hasClass('menu_opended') ? t.removeClass('menu_opended').children('.sub-menu').slideUp(200) : t.addClass('menu_opended').children('.sub-menu').slideDown(200)
    };
      
});

/* Varient Size radio Select js code */
jQuery(document).ready(function($) {
	$('.js.size-option input[name="Size"]').change(function(){
		var value = $('.js.size-option  input[name=Size]:checked').val();
      	$('.select select[name="options[Size]"]').val(value).change();
	});
});



/* Challange product js code */
jQuery(document).ready(function($) {
  
  	var refreshCode = setInterval(function() {
		if ($(".mw-apo-container select").length > 0 ){
			jQuery(".challengep1 select").trigger("change");
          	jQuery(".challengep2 select").trigger("change");
          	jQuery(".challengep3 select").trigger("change");
          	jQuery(".challengep4 select").trigger("change");
          
			clearInterval(refreshCode);
		}
	}, 500);
  	  
	jQuery(document).on('change', '.challengep1 select', function() {
      	var skup1 = jQuery(".challengep1 .mw-text[data-mw-option-value-description-text]").text().trim();
      	jQuery(".challenge-sku1").remove();
      	jQuery(this).after('<input class="challenge-sku1" type="hidden" name="properties[Product SKU 1]" value="'+skup1+'" />');
    });
  	jQuery(document).on('change', '.challengep2 select', function() {
      	var skup2 = $(".challengep2 .mw-text[data-mw-option-value-description-text]").text().trim();
      	jQuery(".challenge-sku2").remove();
      	jQuery(this).after('<input class="challenge-sku2" type="hidden" name="properties[Product SKU 2]" value="'+skup2+'" />');
    });
  	jQuery(document).on('change', '.challengep3 select', function() {
      	var skup3 = jQuery(".challengep3 .mw-text[data-mw-option-value-description-text]").text().trim();
      	jQuery(".challenge-sku3").remove();
      	jQuery(this).after('<input class="challenge-sku3" type="hidden" name="properties[Product SKU 3]" value="'+skup3+'" />');
    });
  	jQuery(document).on('change', '.challengep4 select', function() {
      	var skup4 = jQuery(".challengep4 .mw-text[data-mw-option-value-description-text]").text().trim();
      	jQuery(".challenge-sku4").remove();
      	jQuery(this).after('<input class="challenge-sku4" type="hidden" name="properties[Product SKU 4]" value="'+skup4+'" />');
    });
});

/* accordion js code */
jQuery(document).ready(function($) {
  	accordion();
});
function accordion() {
    var Accordion = function(el, multiple) {
        this.el = el || {};
        this.multiple = multiple || false;

        // Variables privadas
        var links = this.el.find('.js-accordion-link');
        // Evento
        links.on('click', {el: this.el, multiple: this.multiple}, this.dropdown)
    }

    Accordion.prototype.dropdown = function(e) {
        var $el = e.data.el,
            $this = $(this),
            $next = $this.next();

        $next.slideToggle();
        $this.parent().toggleClass('is-open');

        if (!e.data.multiple) {
            $el.find('.js-accordion-content').not($next).slideUp().parent().removeClass('is-open');
            $el.find('.js-accordion-content').not($next).slideUp();
        };
    }
    var accordion = new Accordion($('#js-accordion'), false);
}

/* accessibility js code */
jQuery( document ).ready(function($) {
  	$('.accessibility[data-acsb="trigger"]').click(function() {
      	event.preventDefault();
      	if ($(".acsb-trigger").length == 0 ){
      		(function(){ var s = document.createElement('script'), e = ! document.body ? document.querySelector('head') : document.body; s.src = 'https://acsbapp.com/apps/app/dist/js/app.js'; s.async = true; s.onload = function(){ acsbJS.init({ statementLink : '', footerHtml : '', hideMobile : false, hideTrigger : true, language : 'en', position : 'left', leadColor : '#543c5a', triggerColor : '#543c5a', triggerRadius : '50%', triggerPositionX : 'right', triggerPositionY : 'bottom', triggerIcon : 'people', triggerSize : 'medium', triggerOffsetX : 20, triggerOffsetY : 20, mobile : { triggerSize : 'small', triggerPositionX : 'right', triggerPositionY : 'bottom', triggerOffsetX : 10, triggerOffsetY : 10, triggerRadius : '50%' } }); }; e.appendChild(s);}());
          	var refreshId = setInterval(function() {
    			if ($(".acsb-trigger").length > 0 ){
              		$(".acsb-trigger").click();
              		clearInterval(refreshId);
            	}
			}, 500);
        }
    });
});